import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Sorry", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "We could not find what you are looking for", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Go Home")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("See Our Projects")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Get In Touch")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLink = _resolveComponent("AppLink")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createElementVNode("section", null, [
      _hoisted_1,
      _hoisted_2,
      _createVNode(_component_AppLink, {
        class: "btn alt-btn",
        to: "/"
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_AppLink, {
        class: "btn",
        to: "/projects"
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_AppLink, {
        class: "btn",
        to: "/contact"
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}